import { render, staticRenderFns } from "./TabChart.vue?vue&type=template&id=65173874&scoped=true"
import script from "./TabChart.vue?vue&type=script&lang=js"
export * from "./TabChart.vue?vue&type=script&lang=js"
import style0 from "./TabChart.vue?vue&type=style&index=0&id=65173874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65173874",
  null
  
)

export default component.exports